module.exports = __webpack_public_path__ + "img/empty-cart.6f28ac06.png";